import { render, staticRenderFns } from "./NodeWithDetail.vue?vue&type=template&id=5b9422c2&scoped=true&"
import script from "./NodeWithDetail.vue?vue&type=script&lang=js&"
export * from "./NodeWithDetail.vue?vue&type=script&lang=js&"
import style0 from "./NodeWithDetail.vue?vue&type=style&index=0&id=5b9422c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9422c2",
  null
  
)

export default component.exports